<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Surat Edaran Anggota</h5>    
            </template>
            <b-form @submit.prevent="openModalConfirm">

                <div class="form-content-wrapper">
                    <label>Surat Edaran Anggota</label>
                    <b-row>
                        <b-col cols="10" md="3">
                         
                                <FormulateForm v-model="pdf">
                                    <FormulateInput v-if="url.length != 0"
                                    ref="urlPDF"
                                    name="urlPDF"
                                    type="file"
                                    :value="url"
                                    help="Format Harus PDF"
                                    accept=".pdf"
                                    validation="mime:application/pdf"
                                    multiple
                                    />

                                    <FormulateInput v-else
                                    type="file"
                                    name="file"
                                    help="Format Harus PDF"
                                    validation="mime:application/pdf"
                                    accept=".pdf"
                                    fileRemove
                                    multiple
                                    />
               
                                </FormulateForm>

                        </b-col>
                        <b-col cols="2">
                            <div v-for="(file, index) in pdf.urlPDF.files" :key="index">
                                <span v-if="url != null">
                                    <b-button size="sm" class="mb-3" variant="pgiBtn" @click="openModalPreviewPDF( file.file.size != null ?file.file : $baseFilePath + file.file.previewData )">View</b-button>
                                </span>
                            </div>
                        </b-col>
                    </b-row>
                </div>
               
                <div class="form-wrapper-btn submit-btn-wrapper">
                    <b-button type="submit" name="jenisBarangUpdatebtn" variant="pgiBtn">Update</b-button>
                </div>
            </b-form>
        </b-card>

        <ModalConfirm  id="modal-hapus-se" title="Confirm Hapus SE" desc="SE Akan Terhapus Permanen" @submit=removeSE />
        <ModalConfirm id="modal-confirm-edit" title="Confirm Edit Merk Barang" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk mengubah merk barang ini?" @submit="onSubmit" />

      
         <!-- MODAL SHOW SE -->
         <b-modal id="modal-SE" size="lg" title="Modal SE">
                <iframe width="100%" height="700" allowfullscreen :src="activePdfPreview" frameborder="0"></iframe>
                <template v-slot:modal-footer="{ cancel }">
                    <b-button variant="secondary" name="closePreviewBtn" @click="cancel()">
                        Close
                    </b-button>
                </template>
            </b-modal>
            
    </div>
</template>

<script>
import Vue from 'vue'
import VueFormulate from '@braid/vue-formulate'

Vue.use(VueFormulate)
export default {
    name: 'surat-edaran-anggota',
    data(){
        return{
            
            id: null,
            initStatus: 0,
            isSubmitting: false,
            input:{
                filePDF: null,
            },
            pdf: {
                urlPDF : {
                    fileList:[]
                }
            },
                     
            url : [],

            pdfRecords:[],
            pdfNewVal:[],
            hapusSE:[],

            activePdfPreview: null,

        }
    }, 
    
    methods:{
 
        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.initStatus = 0
            this.id = this.$route.params.id

            let getSe = this.$axios.get("surat-edaran/list/?menu=anggota&jenis=anggota").then(response => {
            for(var file of response.data){
                    this.url.push({
                        id: file.id,
                        url:file.filepath,
                    })
                }

            this.urlRecord = this.url
            })

            Promise.all([getSe]).then(() => {
                this.initStatus = 1
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })
        },

        toBase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader()
                reader.readAsDataURL(file)
                reader.onload = () => resolve(reader.result)
                reader.onerror = error => reject(error)
            })

        },

        openModalPreviewPDF(pdf){
            if(pdf.size != null){  
                    this.toBase64(pdf).then(async base64 => {   

                    this.activePdfPreview = base64
                 })
                
            }

            this.activePdfPreview = pdf
            this.$bvModal.show("modal-SE")
        },

        removeSE(){
    
            for(var file of this.pdf.urlPDF.files){
               let idx = this.pdfNewVal.findIndex(item => item.name == file.name)
               if(idx == -1){
                if(file.path.id != undefined){
                    this.hapusSE.push(file.path.id)
                }
               }
            }
            this.pdf.urlPDF.files = this.pdfNewVal
            this.pdfRecords = this.pdfNewVal
            this.$bvModal.hide("modal-hapus-se")
        },

        openModalConfirm(){
      
            if(this.input.filePDF != null){

           if(this.input.filePDF != null){
            for(var file of this.input.filePDF){
                    if(file.type != null){
                            if(file.type != "application/pdf" ){
                            this.$helper.toastErr(this, 'file '+file.name+' bukan PDF')
                            return
                        }
                    }else{
                            if(file.file.type != "application/pdf"){
                            this.$helper.toastErr(this, 'file '+file.name+' bukan PDF')
                            return
                        }
                    } 
                }
            }
        }

             this.$bvModal.show("modal-confirm-edit")
        },


        onSubmit() {
            this.isSubmitting = true
            let payload = new FormData()
            payload.append("menu" , "anggota")
            payload.append("jenis" , "anggota")
             //File PDF
             if( this.input.filePDF != null){
                for(var file of this.input.filePDF ){

                    if(file.size != null){
                        //untuk struktur form file baru
                      
                        payload.append("pdfFiles" , file)
                    }
                    else if (file.file.size != null){
                         //untuk struktur form file Lama
                        payload.append("pdfFiles" , file.file)
                    }else {
                        //Jika tidak Update Kirim File Kosong
                        let metadata = {
                            type: 'application/pdf'
                        }
                        let fileInput = new File([],"pdf",metadata)
                        payload.append("pdfFiles" , fileInput)
                    }
                }
            }

          
            //Hapus se jika ada
            if(this.hapusSE.length != 0){
                for(var id of this.hapusSE){
                        let payloadHapus = new FormData()
                        payloadHapus.append("id", id)
                        this.$axios.post("surat-edaran/delete/", payloadHapus)
                }    
            }
   
            //----------------- Submit Semua Data -----------------

            this.isSubmitting = true
            this.$axios.post("surat-edaran/insertOrUpdate/",payload).then(() => {
                this.$helper.setFlash(`Jenis barang telah berhasil diubah!`)
               
                location.reload()
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })

        },


    },
    // formulate-file-remove
    watch : {
        "pdf.urlPDF.files" : function(newVal){
            //Hapus SE
            if(this.pdfRecords.length > newVal.length){
                this.pdf.urlPDF.files = this.pdfRecords
                this.pdfNewVal = newVal
                this.$bvModal.show("modal-hapus-se")
            }
            //Tambah SE
            else {
            let pdf = []
            for(var file of this.pdf.urlPDF.files){
                pdf.push(file)
            }
            this.input.filePDF = pdf
            this.pdfRecords = pdf
            }

        },

        "pdf.file.fileList" : function(){
            let Pdfbase64 = []
            for(var file of this.pdf.file.fileList){
                Pdfbase64.push(file)
            }
            this.input.filePDF = Pdfbase64
        },
        "url" : function(){
        }
    },

    created(){
        this.init()
    }
}
</script>
